import debounce from 'lodash-es/debounce';

/*
 * Memoization ES6 decorator for getter methods
 * Copied from http://www.couchcoder.com/using-memoized-decorator-cache-computed-properties/
 */
export const memoizeGetter = (target, propertyKey, descriptor) => {
  const originalGet = descriptor.get;

  descriptor.get = function memoizedGetter() {
    if (!Object.prototype.hasOwnProperty.call(this, '__memoized__')) {
      Object.defineProperty(this, '__memoized__', { value: new Map() });
    }

    return this.__memoized__.has(propertyKey)
      ? this.__memoized__.get(propertyKey)
      : (() => {
          const value = originalGet.call(this);
          this.__memoized__.set(propertyKey, value);
          return value;
        })();
  };
};

export const deb = (wait = 0, options = {}) => (
  target,
  propertyKey,
  descriptor,
) => {
  descriptor.value = debounce(descriptor.value, wait, options);
  return descriptor;
};
